/**
 * @author Sarthak Sharma.
 * @since 03-01-2024.
 * @type {string} Recruiter action types.
 */

export const SET_LOADING = "[RECRUITER] SET_LOADING";
export const SET_RECRUITER_LIST = "[RECRUITER] SET_RECRUITER_LIST";
export const SET_RECRUITER_LIST_META = "[RECRUITER] SET_RECRUITER_LIST_META";
export const SET_RECRUITER = "[RECRUITER] SET_RECRUITER";
export const SET_RECRUITER_PROFILE_LIST =
  "[RECRUITER] SET_RECRUITER_PROFILE_LIST";
export const SET_RECRUITER_PROFILE_LIST_META =
  "[RECRUITER] SET_RECRUITER_PROFILE_LIST_META";
export const SET_SELECTED_RECRUITER = "[RECRUITER] SET_SELECTED_RECRUITER";
export const APPEND_RECRUITER_PROFILE_LIST =
  "[RECRUITER] APPEND_RECRUITER_PROFILE_LIST";
export const SET_RECRUITER_PROFILE = "[RECRUITER] SET_RECRUITER_PROFILE";
export const SET_RECRUITER_AUDITION = "[RECRUITER] SET_RECRUITER_AUDITION";
export const SET_RECRUITER_IMAGES = "[RECRUITER] SET_RECRUITER_IMAGES";
